module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl1-75.de053f7d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl1-75.png
// module id = 3299
// module chunks = 11